import { render, staticRenderFns } from "./WebsitePage.vue?vue&type=template&id=3545ae52&lang=pug&"
import script from "./WebsitePage.vue?vue&type=script&lang=ts&"
export * from "./WebsitePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports